const localeReplacementTable = {
  pt: 'es',
  it: 'fr',
  ja: 'es',
  zh: 'fr',
  ar: 'es',
  tr: 'fr',
  de: 'fr',
  ca: 'fr',
};

export default localeReplacementTable;
